import axios from '@/user/axios'
import { setUserProperties } from '@/ga/user'

const storageData = JSON.parse(sessionStorage.getItem('ubunconsole'))
let activeAccount = {}
let accounts = []

if (storageData) {
  activeAccount = storageData.account.activeAccount
  accounts = storageData.account.accounts
}

const moduleAccount = {
  namespaced: true,
  state: {
    activeAccount, // TODO 二重管理になるのでstateではidのみ保持して、gettersで管理したほうがいいが、修正範囲が多いので後日別のブランチ切って行う
    accounts: accounts || []
  },
  getters: {
    isActiveAccountConnected: state => state.activeAccount.spApiOauthComplete,
    isActiveAccountAdConnected: state => state.activeAccount.adApiOauthComplete,
    isActiveAccountNeedReauth: state => state.activeAccount.isNeedReauth,
    isActiveAccountAdminAndPlanA: state => state.activeAccount.isAdminAndPlanA
  },
  mutations: {
    SET_ACCOUNTS: (state, payload) => {
      state.accounts = payload
    },
    UPDATE_ACCOUNT: (state, payload) => {
      const index = state.accounts.findIndex(account => account.id === payload.id)
      state.accounts = [
        ...state.accounts.slice(0, index),
        {
          ...state.accounts[index],
          ...payload
        },
        ...state.accounts.slice(index + 1)
      ]
      if (state.activeAccount.id === payload.id) {
        state.activeAccount = {
          ...state.activeAccount,
          ...payload
        }
      }
    },
    UPDATE_ACCOUNT_INFO: (state, payload) => {
      setUserProperties({
        ubun_account_id: payload.id
      })
      state.activeAccount = payload
    }
  },
  actions: {
    getAccount ({ commit, state }) {
      return new Promise(async (resolve, reject) => {
        const accountId = state.activeAccount.id
        axios.get(`/api/accounts/${accountId}`)
          .then(resp => {
            commit('UPDATE_ACCOUNT', resp.data.data)
            resolve(resp)
          }).catch(err => {
            reject(err)
          })
      })
    },
    updateAccount (context, payload) {
      return new Promise(async (resolve, reject) => {
        const { id, ...data } = payload
        try {
          const res = await axios.put(`/api/accounts/${id}`, data)
          context.commit('UPDATE_ACCOUNT', res.data.data)
          resolve(res)
        } catch (err) {
          reject(err)
        }
      })
    },
    changeAccount: ({ commit }, payload) => {
      commit('UPDATE_ACCOUNT_INFO', payload)
    },
    addAccount (context, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axios.post('/api/accounts/', payload)
          resolve(res)
        } catch (err) {
          reject(err)
        }
      })
    }
  }
}

export default moduleAccount
